<template>
  <div id="app" :class="[activeTemplate, {transitioning: getViewTransitioning(), 'offscreen': watHeader}]">
    <div class="loader" :class="{'display': !siteReady}" v-if="showLoader"></div>
    <MainHeader v-on:toggleMenu="toggleMenu" :showMenu="showMenu" v-on:changeSlide='changeSlide' v-on:changeView='changeView' :slideIndex="activeSlide" :viewIndex="activeIndex" :hideHeader="hideHeader"/>
    <MainMenu v-on:toggleMenu="toggleMenu" :showMenu="showMenu" v-on:changeView='changeView' v-on:changeSlide='changeSlide' :viewIndex="activeIndex"/>
    <Views 
      :viewIndex="activeIndex"
      :viewTransitioning="getTransitioning"
      :slideIndex="activeSlide"
      :getSlideIndex="getSlideIndex"
      v-on:changeView='changeView'
      v-on:changeSlide='changeSlide'
      v-on:changeTransitioning='changeTransitioning'
      v-on:clearTransitioning='clearTransitioning'
      v-if="siteReady"
    />
  </div>
</template>

<script>
  import store from '../store.js';
  import Views from './Views.vue';
  import MainHeader from './MainHeader.vue';
  import MainMenu from './MainMenu.vue';


  export default {
    name: 'app',
    components: {
      Views,
      MainHeader,
      MainMenu
    },
    methods: {
      changeSlide: (val) => {
        // console.log('wat', store.state.showMenu)
        if(!store.state.showMenu){
          return store.commit('updateSlideIndex', val);
        }
      },
      changeView: (val) => {
        return store.commit('updateViewIndex', val);
      },
      changeTransitioning: () => {
        return store.commit('updateViewTransitioning');
      },
      clearTransitioning: () => {
        return store.commit('clearTransitioning');
      },
      getTransitioning: (index) => {
        return store.state.views[index].transitioning
      },
      getViewTransitioning: (index) => {
        return store.state.viewTransitioning
      },
      toggleMenu: () => {
        return store.commit('toggleMenu');
      },
      getSlideIndex: (i) => {
        // console.log(view.index)
        // console.log(store.state.views[i])
        if(store.state.views[i]){
          return store.state.views[i].slideIndex
        }
      },
      makeSiteReady: () => {
        return store.commit('makeSiteReady');
      },
      showSite: function () {
        let _this = this;
        setTimeout(function(){
          _this.makeSiteReady()
        }, 1000)
      },
      handleKey (e) {
        let { activeSlide, activeIndex } = this;
        var key = e.keyCode ? e.keyCode : e.which;
        if(activeIndex === 0 && (activeSlide === 0 || activeSlide === 1 )){
          return 
        }
        if(key === 40){
          // console.log('next slide')
          this.gotoNextSlide();
        } else if(key === 38) {
          this.gotoPrevSlide();
        } 
      },
      handleScroll (event) {
        let e = window.event || event;
        let delta = e.wheelDelta || -e.detail;
        
        if (delta < -50 || delta > 50) {
          let { activeSlide, activeIndex } = this;
          let dir = -1*(Math.max(-1, Math.min(1, delta)));
          let newSlide = activeSlide + dir;

          if(!(activeIndex === 0 && (activeSlide === 0 || activeSlide === 1 ))){
            this.changeSlide(newSlide);
          }
        }
        e.preventDefault();
      },
      scrollTop (event) {
        let slide = document.querySelector('.slide.active');
        var header = document.getElementById('header')
        if(slide.scrollTop > 0) {
          header.classList.add('offscreen')
          // this.hideHeader = true;
        } else {
          header.classList.remove('offscreen')
          // this.hideHeader = false
        }
        console.log(slide.scrollTop, this.hideHeader)
      },
      gotoNextSlide: function() {
        this.changeSlide(this.activeSlide + 1)
      },
      gotoPrevSlide: function() {
        this.changeSlide(this.activeSlide - 1)
      },
      activePage: function () {
        return this.$content[this.activeIndex].id
      }
    },
    computed: {
      activeIndex: () => {
        return store.state.viewIndex
      },
      activeSlide: () => {
        return store.state.views[store.state.viewIndex].slideIndex
      },
      // activeSlideByIndex: (i) => {
      //   return store.state.views[i].slideIndex
      // },
      showMenu: () => {
        return store.state.showMenu;
      },
      activeTemplate () {
        return this.$content[this.activeIndex].slides[this.activeSlide].template
      },
      siteReady: () => {
        return store.state.siteReady;
      },
      showLoader: () => {
        return store.state.showLoader
      },
      watHeader () {
        return store.state.hideHeader;
      }
    },
    created() {
      this.hideHeader = false;
      let assetManifest = [
        require('../assets/images/homepage-0-bg.jpg'),
        require('../assets/images/homepage-2-bg.jpg'),
        require('../assets/images/homepage-airplane.png'),
        require('../assets/images/convenience-0-image.jpg'),
        require('../assets/images/neighbor-0-bg.jpg'),
        require('../assets/images/neighbor-1-bg.jpg'),
        require('../assets/images/sound-0-bg.jpg'),
        require('../assets/images/security-0-image.jpg'),
        require('../assets/images/security-0-supp.png'),
        require('../assets/images/convenience-0-supp.png')
      ];

      let queue = new createjs.LoadQueue(false);
      queue.on("complete", this.showSite);
      queue.loadManifest(assetManifest);

      document.addEventListener("touchmove", this.scrollTop, false);

      window.addEventListener("mousewheel", this.handleScroll, false);
      window.addEventListener("DOMMouseScroll", this.handleScroll, false);
      window.addEventListener('keyup', this.handleKey, false)
    },
    destroy () {
      window.removeEventListener("mousewheel", this.handleScroll, false);
      window.removeEventListener("DOMMouseScroll", this.handleScroll, false);
      window.removeEventListener('keyup', this.handleKey, false)
    }
  } 
</script>

<style lang="scss">
@import '../sass/inc';

  #app {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;
    // &.transitioning{
    //   .slide{
    //     opacity: 0;
    //     &.active{
    //       opacity: 1!important;
    //     }
    //   }
    // }
    &.hideHeader{
      #header{
        transform: translate(0, -100%);
      }
    }
  }
  .loader{
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 999;
    top: 0;
    left: 0;
    background-image: url('../assets/images/homepage-0-bg.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    opacity: 0;
    transition: opacity 800ms ease-out 400ms, transform 1200ms ease-in-out;
    transform: scale(1.1);
    pointer-events: none;
    &.display{
      opacity: 1;
      transform: scale(1.4);
      pointer-events: auto;
    }
  }
</style>
